import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';

@withRouter
@inject("store")
@observer
export default class HeroCourse extends Component
{
    // constructor(props) 
    // {
    //     super(props);
    // }
    
    // componentDidMount()
    // {
    //    // 
    // }

    // componentDidUpdate(prevProps)
    // {
    //     if (this.props.data !== prevProps.data) 
    //     {
           
    //     }
    // }
    
    render()
    {
        return <><div className="ft-hero-div">
        <div className="container">
            <div className={"hero-box level1 ft-bg-"+this.props.data.color||"blue"}>
                <img src={this.props.data.img} onClick={()=>{ this.props.data.target == '_blank' ? window.open(this.props.data.url,'_blank') : this.props.history.push(this.props.data.url)}}/>
            </div> 
        </div>
    </div></> ;
    }
}